"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = rootSaga;
var _effects = require("redux-saga/effects");
var _selectors = require("@otpusk/apisearch-toolbox/dist/offers/selectors");
var _selectors2 = require("@otpusk/apisearch-toolbox/dist/hotels/selectors");
var _helpers = require("@otpusk/apisearch-toolbox/dist/geo/helpers");
var _selectors3 = require("@otpusk/apisearch-toolbox/dist/geo/selectors");
var _getOfferSaga = require("@otpusk/apisearch-toolbox/dist/offers/saga/getOfferSaga");
var _selectors4 = require("@otpusk/apisearch-toolbox/dist/queries/selectors");
var _fn = require("@otpusk/apisearch-toolbox/dist/queries/fn");
var R = _interopRequireWildcard(require("ramda"));
var _actions = require("../../../../../../../bus/ui/actions");
var _localization = _interopRequireDefault(require("../../../../../../../localization"));
var _api = require("../../../../../../../helpers/api");
var _config = require("../../../../../../../services/config");
var _ConfirmModal = require("../../../../../../ConfirmModal");
var _actions2 = require("../actions");
var _constants = require("../constants");
var _saveOfferToClaimSaga = require("./saveOfferToClaimSaga");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i.return && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, catch: function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
var _marked = /*#__PURE__*/_regeneratorRuntime().mark(redirectToTourOperatorWebSite),
  _marked2 = /*#__PURE__*/_regeneratorRuntime().mark(rootSaga);
var openBookingPage = function openBookingPage(url) {
  return global.window.open(url, '_blank');
};
var isSetBookingURL = function isSetBookingURL(offer) {
  return R.prop('bookingUrl', offer);
};
function redirectToTourOperatorWebSite(countryID, offer) {
  var bookingUrl, operatorID, operator, onRedirectToOperatorSite;
  return _regeneratorRuntime().wrap(function redirectToTourOperatorWebSite$(_context) {
    while (1) switch (_context.prev = _context.next) {
      case 0:
        bookingUrl = offer.bookingUrl, operatorID = offer.operator;
        _context.next = 3;
        return (0, _effects.select)(function (state) {
          var params = {
            key: (0, _helpers.generateOperatorKey)(countryID, offer.departure),
            operatorID: operatorID
          };
          return (0, _selectors3.getOperator)()(state, params);
        });
      case 3:
        operator = _context.sent;
        onRedirectToOperatorSite = (0, _config.getOnRedirectToOperatorSiteByOffer)();
        if (onRedirectToOperatorSite) {
          onRedirectToOperatorSite(operator);
        }
        _context.next = 8;
        return (0, _effects.call)(openBookingPage, bookingUrl);
      case 8:
      case "end":
        return _context.stop();
    }
  }, _marked);
}
function handleBookingSaga(_ref) {
  var _ref$payload = _ref.payload,
    countryID = _ref$payload.countryID,
    offerID = _ref$payload.offerID;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var offer, offerByApi;
    return _regeneratorRuntime().wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 2:
          offer = _context2.sent;
          if (!isSetBookingURL(offer)) {
            _context2.next = 8;
            break;
          }
          _context2.next = 6;
          return (0, _effects.call)(redirectToTourOperatorWebSite, countryID, offer);
        case 6:
          _context2.next = 26;
          break;
        case 8:
          _context2.next = 10;
          return (0, _effects.put)((0, _actions.register)(_constants.BOOKING_UI_KEY, {
            loading: true
          }));
        case 10:
          _context2.prev = 10;
          _context2.next = 13;
          return (0, _effects.call)(_getOfferSaga.getOfferSaga, offerID);
        case 13:
          offerByApi = _context2.sent;
          _context2.next = 16;
          return (0, _effects.call)(redirectToTourOperatorWebSite, countryID, offerByApi);
        case 16:
          _context2.next = 22;
          break;
        case 18:
          _context2.prev = 18;
          _context2.t0 = _context2["catch"](10);
          _context2.next = 22;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            header: _localization.default.t('RESULT_CARD:BOOKING_NOT_FOUND_LINK_ERROR_TEXT'),
            confirmButton: false,
            cancelButton: false
          }));
        case 22:
          _context2.prev = 22;
          _context2.next = 25;
          return (0, _effects.put)((0, _actions.unRegister)(_constants.BOOKING_UI_KEY));
        case 25:
          return _context2.finish(22);
        case 26:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[10, 18, 22, 26]]);
  })();
}
function copyOfferToBufferSaga(_ref2) {
  var payload = _ref2.payload;
  return /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var offerID, queryID, transport, currency, offer, hotel, patchedOffer, errorMsg;
    return _regeneratorRuntime().wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          offerID = payload.offerID, queryID = payload.queryID;
          transport = (0, _config.getOnCopyOfferToBuffer)();
          if (transport) {
            _context3.next = 4;
            break;
          }
          return _context3.abrupt("return", false);
        case 4:
          _context3.next = 6;
          return (0, _effects.put)((0, _actions.setIsVisibleGlobalLoader)(true));
        case 6:
          _context3.prev = 6;
          _context3.next = 9;
          return (0, _effects.select)(function (state) {
            return (0, _selectors4.getQueryParam)(state, {
              queryID: queryID,
              paramName: _fn.QUERY_PARAMS.CURRENCY
            });
          });
        case 9:
          currency = _context3.sent;
          _context3.next = 12;
          return (0, _effects.select)(function (state) {
            return (0, _selectors.getActualizedOffer)()(state, {
              offerID: offerID
            }) || (0, _selectors.getOffer)()(state, {
              offerID: offerID
            });
          });
        case 12:
          offer = _context3.sent;
          _context3.next = 15;
          return (0, _effects.select)(function (state) {
            return (0, _selectors2.getHotel)()(state, offer.hotelId);
          });
        case 15:
          hotel = _context3.sent;
          patchedOffer = R.assoc('currency', currency, offer);
          _context3.next = 19;
          return (0, _effects.call)(transport, patchedOffer, hotel);
        case 19:
          _context3.next = 21;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            header: _localization.default.t('RESULT_CARD:SUCCESS_COPY_OFFER_TO_BUFFER_HEADER_AT_MODAL'),
            content: _localization.default.t('RESULT_CARD:SUCCESS_COPY_OFFER_TO_BUFFER_DESCRIPTION_AT_MODAL'),
            confirmButtonText: _localization.default.t('RESULT_CARD:COPY_OFFER_TO_BUFFER_CONFIRM_BUTTON_AT_MODAL'),
            cancelButton: false
          }));
        case 21:
          _context3.next = 31;
          break;
        case 23:
          _context3.prev = 23;
          _context3.t0 = _context3["catch"](6);
          console.log(_context3.t0);
          _context3.next = 28;
          return (0, _effects.call)(_api.getErrorMessage, _context3.t0);
        case 28:
          errorMsg = _context3.sent;
          _context3.next = 31;
          return (0, _effects.put)((0, _ConfirmModal.showConfirmModal)(undefined, {
            content: errorMsg || _localization.default.t('API_REQUESTS_ERRORS:ERROR_SERVER'),
            confirmButtonText: _localization.default.t('RESULT_CARD:COPY_OFFER_TO_BUFFER_CONFIRM_BUTTON_AT_MODAL'),
            cancelButton: false
          }));
        case 31:
          _context3.prev = 31;
          _context3.next = 34;
          return (0, _effects.put)((0, _actions.setIsVisibleGlobalLoader)(false));
        case 34:
          return _context3.finish(31);
        case 35:
        case "end":
          return _context3.stop();
      }
    }, _callee2, null, [[6, 23, 31, 35]]);
  })();
}
function rootSaga() {
  return _regeneratorRuntime().wrap(function rootSaga$(_context4) {
    while (1) switch (_context4.prev = _context4.next) {
      case 0:
        _context4.next = 2;
        return (0, _effects.all)([(0, _effects.takeEvery)(_actions2.booking, handleBookingSaga), (0, _effects.takeEvery)(_actions2.copyOfferToBuffer, copyOfferToBufferSaga), (0, _effects.takeEvery)(_actions2.saveOfferToClaim, _saveOfferToClaimSaga.saveOfferToClaimSaga)]);
      case 2:
      case "end":
        return _context4.stop();
    }
  }, _marked2);
}